import { formatCpf } from '@brazilian-utils/brazilian-utils';

export class StringManager {
  static snakeToCamel(key: string) {
    throw new Error("Method not implemented.");
  }
  static onlyNumbers(value: string) {
    if (!value) throw new Error('Argument value is required');

    const onlyNumbers = value
      .replace(/[^0-9]/g, '')
      .split('')
      .map(Number)
      .join('');

    if (onlyNumbers.length === 0)
      throw new Error('Argument value must contain at least one number');

    return onlyNumbers;
  }
  static filledString(text?: string | null) {
    if (text === undefined || text === null) return undefined;
    if ((text ?? '').length > 0) return text;
    return undefined;
  }
  static throwIfEmpty(text?: string | null, key?: string) {
    if (text === undefined || text === null || (text ?? '').length === 0)
      throw new Error(`${key} is required`);
    return text;
  }
  static convertFromSnakeCaseToCamelCase(text: string) {
    if (text === undefined || text === null || (text ?? '').length === 0)
      throw new Error('String cannot be empty');
    return text.replace(/_/g, '-');
  }
  static onlyLetters(text: string) {
    return text.replace(/[^A-Za-zÁ-ú\s]/g, '');
  }
  static formatZipCode(zipCode: string, country = 'BR') {
    if (country === 'BR') return this.onlyNumbers(zipCode);

    const alphanumericZipCode = (zipCode ?? '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    if (alphanumericZipCode.length === 0)
      throw new Error('Argument value must contain at least one character');

    return alphanumericZipCode;
  }
  static formatBrazilianCeP(zipCode?: string) {
    if (!zipCode) return;
    const cleanedZipCode = zipCode.replace(/\D/g, '');

    const formattedZipCode = cleanedZipCode.replace(/(\d{5})(\d{3})/, '$1-$2');

    return formattedZipCode;
  }
  static formatCpf(cpf?: string) {
    if (cpf === undefined || cpf === null) return '';

    return formatCpf(cpf);
  }

  static formatCnpj(cnpj?: string) {
    if (cnpj === undefined || cnpj === null) return '';

    const cleanCNPJ = cnpj.replace(/[^A-Z0-9]/gi, '').toUpperCase();

    if (cleanCNPJ.length !== 14) {
      return cnpj;
    }

    return `${cleanCNPJ.slice(0, 2)}.${cleanCNPJ.slice(
      2,
      5
    )}.${cleanCNPJ.slice(5, 8)}/${cleanCNPJ.slice(
      8,
      12
    )}-${cleanCNPJ.slice(12)}`;
  }

  static getParamBetweenSlash({url, paramPosition = 1}:{url:string, paramPosition?: number }) {
    const splittedUrl = url.split('/')
    if(paramPosition > splittedUrl.length) throw new Error('Invalid path param position')
    return url.split('/')[paramPosition]
  }
}
